module.exports = __webpack_public_path__ + "img/candidate-green.b6f59636.png";